import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import DealsHistoryTable from 'presentation/components/modules/portfolio/dealsHistory/DealsHistoryTable';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading, {
  GridHeadingTrailingLink,
} from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useFetchPortfolioQuery } from 'rtkQuery/sharespro/queries/portfolio';

interface Props {
  gridHeadingLink?: GridHeadingTrailingLink;
  limit?: number;
}

const PortfolioDealsHistoryContainer: FC<Props> = ({
  gridHeadingLink,
  limit,
}) => {
  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch, isFetching } = useFetchPortfolioQuery({
    period,
    account_id: accountId,
  });

  const { t } = useTranslation();

  if (!data) {
    if (isFetching) {
      return (
        <>
          <GridHeading>{t('portfolioDealsHistoryTitle')}</GridHeading>
          <AppCard
            p="20px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner />
          </AppCard>
        </>
      );
    } else if (error) {
      return (
        <>
          <GridHeading>{t('portfolioDealsHistoryTitle')}</GridHeading>
          <AppCard
            p="20px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ErrorContainer
              error={error}
              onRetry={() => {
                refetch();
              }}
            />
          </AppCard>
        </>
      );
    } else {
      return (
        <>
          <GridHeading>{t('portfolioDealsHistoryTitle')}</GridHeading>
          <AppCard
            p="20px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner />
          </AppCard>
        </>
      );
    }
  }

  const deals = accountId
    ? data.accounts.items.find((item) => item.id === accountId)?.deals ?? []
    : data.accounts.items.flatMap((item) => item.deals);

  if (deals.length === 0) {
    return null;
  }

  const displayedDeals = limit ? deals.slice(0, limit) : deals;
  const showLink = !limit || deals.length > limit;

  return (
    <>
      <GridHeading trailingLink={showLink ? gridHeadingLink : undefined}>
        {t('portfolioDealsHistoryTitle')}
      </GridHeading>
      <AppCard
        p="20px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <DealsHistoryTable items={displayedDeals} />
      </AppCard>
    </>
  );
};

export default PortfolioDealsHistoryContainer;
